import React, { useState, useEffect } from 'react'
import {Container, Segment, Dimmer, Loader, Header} from 'semantic-ui-react'
import { publicApi } from '../misc/PublicApi'
import { handleLogError } from '../misc/Helpers'
import { getPoint } from '../misc/Helpers'
import {Link} from "react-router-dom";

function Home() {
  const [qmap, setQmap] = useState({
    "stone_log": {
      "bus": 10,
      "car": 60,
      "pointTime": "2025-05-25T15:00:00.000+00:00"
    },
    "grigorov": {
      "bus": 0,
      "car": 10,
    },
    "brest": {
      "bus": 30,
      "car": 915,
    },
    "benekainys": {
      "bus": 0,
      "car": 50,
    }
  })
  const [rmap, setRmap] = useState({
    "stone_log": {
      "total": 6,
    },
    "grigorov": {
      "total": 6,
    },
    "brest": {
      "total": 6,
    },
    "benekainys": {
      "total": 6,
    }
  })
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    fetchMap()
  }, [])

  const fetchMap = async () => {
    setIsLoading(true)
    try {
      const responseMap = await publicApi.getQueueMap()
      setQmap(responseMap.data)
      const responseMap2 = await publicApi.getReportMap()
      setRmap(responseMap2.data)
    } catch (error) {
      handleLogError(error)
    } finally {
      setIsLoading(false)
    }
  }

  if (isLoading) {
    return (
      <Segment basic style={{ marginTop: window.innerHeight / 2 }}>
        <Dimmer active inverted>
          <Loader inverted size='huge'>Loading</Loader>
        </Dimmer>
      </Segment>
    )
  }

  return (
    <Container text>
      <Header as='h3' textAlign='center'>Добро пожаловать на мини-сайт VPUT.BY - помощник в пересечении границы Беларуси с соседними странами</Header>
      <Header as='h3'><Link to="/searchreports">Отчёты о Недавних Поездках</Link></Header>
      <Header as='h3'><Link to="/createreport">Оставить Отчёт</Link></Header>
      <Header as='h3'><Link to="/trips">Поиск Водителя / Транспорта</Link></Header>
      <Header as='h3'><Link to="/createtrip">Поиск Попутчиков</Link></Header>
      <Header as='h3'><Link to="/about">Полезная Информация</Link></Header>
      <Header as='h3' textAlign='center'>Текущая Ситуация на {new Date(qmap.stone_log.pointTime).toLocaleString('ru',
            { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false })}</Header>
      <Header as='h5'>{getPoint('stone_log')} - Автобусы {qmap.stone_log.bus}, Легковые авто {qmap.stone_log.car}</Header>
      <Header as='h5'>{getPoint('benekainys')} - Автобусы {qmap.benekainys.bus}, Легковые авто {qmap.benekainys.car}</Header>
      <Header as='h5'>{getPoint('brest')} - Автобусы {qmap.brest.bus}, Легковые авто {qmap.brest.car}</Header>
      <Header as='h5'>{getPoint('grigorov')} - Автобусы {qmap.grigorov.bus}, Легковые авто {qmap.grigorov.car}</Header>
    </Container>
  )
}

export default Home
